import React, { Component } from "react";
import { connect } from "react-redux";
import ProgressBar from "../../../_components/common/ProgressBar";

import Ratingtear from "../../../images/tear-drop.png";
import QuestionCrumbs from "../../../_components/QuestionCrumbs/index";
import {

  Button,
  Modal,

  ModalBody,

} from "reactstrap";
import InputRange from "react-input-range";

import { respondentsAssessmentAction } from "../../../_actions/Assessments/respondentsAssessment.action";
import { onSubmitAssessmentAction } from "../../../_actions/Assessments/submitAssessment.action";
import "react-input-range/lib/css/index.css";
import "./index.css";
import Joyride from "react-joyride";
import PropTypes from "prop-types";
import swal from "sweetalert2";

import successModalImage from "../../../images/successModalImage.png";
import Stopwatch from "../../../images/Stopwatch.svg";
import Honesty from "../../../images/Honesty.svg";
import Neutral from "../../../images/Neutral.svg";

class MultiRater extends Component {
  state = {
    is_info_open: false,
    currentQuestion: null,
    value: 0,
    question_count: 0,
    options: this.props.mainData.instument.instrument_options,
    initial_green_indicator: false,
    infoModal: "true",
    infoModal_bool: true,
    question_itration: 0,
    empty_questions: 0,
    steps: [
      {
        title: (
          <div>
            <h5>STEP-1</h5>
          </div>
        ),
        target: ".panel-one",
        content: (
          <div>
            <h5>
              Read each question carefully. There are some negative questions.
            </h5>
          </div>
        ),
        placement: "bottom",
        locale: { open: "Step 1 - Walkthrough" },
        disableBeacon: true,
        offset: 0,
      },

      {
        title: (
          <div>
            <h5>STEP-2</h5>
          </div>
        ),
        target: ".panel-three",
        content: (
          <div>
            <h5>Drag the slider to mark your answer. Be honest, please!</h5>
          </div>
        ),
        placement: "bottom",
        locale: { open: "Step 2" },
        offset: 0,
      },
      {
        title: (
          <div>
            <h5>STEP-3</h5>
          </div>
        ),
        target: ".panel-four",
        content: (
          <div>
            <h5> Finalize your answer and proceed to the next question. </h5>
            <h5 className="text-danger">
              (You cannot go back to a previous question)
            </h5>
          </div>
        ),
        placement: "bottom",
        locale: { open: "Step 3" },
        offset: 0,
      },
    ],
    slideOnCompleteData: {},
    disableNextButton: false,
  };

  componentWillMount() {
    const { currentDashboardObj } = this.props;
    if (
      currentDashboardObj.is_self_assessment_completed ||
      currentDashboardObj.is_submited
    ) {
      window.location.replace("/app/dashBoard");
    }
  }

  componentDidMount() {
    const { dispatch, mainData, currentDashboardObj } = this.props;
    let goodToGo = true;

    mainData.questions_list.map((val, key) => {

      if (goodToGo) {
        if (Object.keys(val.user_response).length === 0) {
          this.setState({ question_itration: key + 1 });
          goodToGo = false;
        }
      }
      if (mainData.questions_list.length == key + 1) {
        if (Object.keys(val.user_response).length !== 0) {
          this.setState({ question_itration: key + 1 });
        }
      }
    });

    if (goodToGo) {
      this.setState({
        question_itration: mainData.questions_list.length,
      });
    }




    let valueInt = 0;
    let initGreenIndicator = true;

    mainData.questions_list.some((val, i) => {
      if (Object.keys(val.user_response).length === 0) {
        valueInt = 5;
        initGreenIndicator = false;
        this.setState({
          currentQuestion: val,
          question_count: this.state.question_count++,
        });
        return true;
      } else if (Object.keys(val.user_response).length !== 0) {
        initGreenIndicator = true;

        valueInt = val.user_response.assessment_value;
        this.setState({
          currentQuestion: val,
          question_count: this.state.question_count++,
        });
      }

    });

    this.setState(
      {
        value: valueInt,
        initial_green_indicator: initGreenIndicator,
        disableNextButton: false,
      }

    );
  }

  sortByKey = (array, key) => {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  };

  progress = (value) => {
    this.setState({ value: parseFloat(value.toFixed(2)) }, () => { });
  };

  onComplete = (value) => {
    const { dispatch, currentDashboardObj, mainData } = this.props;

    const { currentQuestion } = this.state;

    const highLightedOption = mainData.instument.instrument_options.filter(
      (obj) => {
        return value >= obj.option_start_value && value <= obj.option_end_value;
      }
    );

    let data1 = mainData.questions_list.length - value;


    const data = {
      organisation: currentDashboardObj.organisation,
      user_assessment:
        currentDashboardObj.participant__id != undefined
          ? currentDashboardObj.id
          : currentDashboardObj.user_assessment__id,
      assessment_option: highLightedOption[0].id,
      user: `${currentDashboardObj.participant__id != undefined
          ? currentDashboardObj.participant__id
          : currentDashboardObj.respondent__id
        }`,
      assessment_question: `${currentQuestion.id}`,

      seller: currentDashboardObj.seller,
      assessment_value:
        currentQuestion.answer_type == true
          ? value.toFixed(2)
          : (10 - value).toFixed(2),
    };

    this.setState({
      slideOnCompleteData: data,
      initial_green_indicator: true,
    });
  };

  clearHistory = () => {
    window.location.replace("/app/dashBoard");
  };

  onClickButton = (total, current) => {
    const { dispatch, currentDashboardObj, mainData } = this.props;
    if (total - 1 == current) {
      this.setState(
        {
          disableNextButton: true,
        },
        () => {
          const data = {
            user_assessment:
              currentDashboardObj.participant__id != undefined
                ? currentDashboardObj.id
                : currentDashboardObj.user_assessment__id,
            user:
              currentDashboardObj.participant__id != undefined
                ? `${currentDashboardObj.participant__id}`
                : `${currentDashboardObj.respondent__id}`,
          };

          dispatch(
            respondentsAssessmentAction.respondentsAssessmentHandler(
              this.state.slideOnCompleteData,
              currentDashboardObj,
              () => {
                dispatch(
                  onSubmitAssessmentAction.onSubmitAssessmentHandler(
                    data,
                    currentDashboardObj,
                    () => {
                      this.setState(
                        {
                          disableNextButton: false,
                        },
                        () => {
                          swal({
                            title:
                              currentDashboardObj.participant__id !== undefined
                                ? "You have successfully completed assessing yourself."
                                : "You have successfully completed assessing " +
                                this.props.currentDashboardObj
                                  .user_assessment__participant__full_name,
                            text:
                              mainData.instument.is_multi_rater &&
                                currentDashboardObj.participant__id !== undefined
                                ? "Next, request people who know you well to give you feedback and then submit your LOI."
                                : "",

                            imageUrl: successModalImage,
                            imageWidth: 400,
                            imageHeight: 200,
                            imageAlt: "Custom image",
                            animation: false,
                            showCancelButton: false,
                          }).then((result) => {
                            if (result.value) {
                              window.location.replace("/app/dashBoard");
                            } else {
                              window.location.replace("/app/dashBoard");
                            }
                          });
                        }
                      );
                    }
                  )
                );
              }
            )
          );
        }
      );
    } else {
      this.setState(
        {
          disableNextButton: true,
        },
        () => {
          dispatch(
            respondentsAssessmentAction.respondentsAssessmentHandler(
              this.state.slideOnCompleteData,
              currentDashboardObj,
              () => {
                this.props.qoestionEvent();
              }
            )
          );
        }
      );
    }
  };

  static propTypes = {
    joyride: PropTypes.shape({
      callback: PropTypes.func,
    }),
  };

  static defaultProps = {
    joyride: {},
  };



  handleJoyrideCallback = (data) => {
    const { joyride } = this.props;
    const { type } = data;

    if (typeof joyride.callback === "function") {
      joyride.callback(data);
    }
  };

  infoToggle = () => {
    this.setState({
      infoModal: "false",
      infoModal_bool: !this.state.infoModal_bool,
    });
  };

  getBackgroundColorOfAnswer = (obj, defaultColor) => {
    return this.state.initial_green_indicator == true
      ? this.state.value >= obj.option_start_value &&
        this.state.value <= obj.option_end_value
        ? "#168e77"
        : defaultColor
      : defaultColor;
  };

  getTextColorOfAnswer = (obj) => {
    return this.state.initial_green_indicator == true
      ? this.state.value >= obj.option_start_value &&
        this.state.value <= obj.option_end_value
        ? "#fff"
        : "#838383"
      : "#838383";
  };

  render() {
    const { currentDashboardObj, example } = this.props;
    const { currentQuestion } = this.state;
    const { steps } = this.state;




    return (
      <React.Fragment>
        {currentQuestion != null
          ? this.props.currentDashboardObj.assessment_status__status_name ===
          "Yet to start" &&
          currentQuestion.question_number ===
          this.props.FirstQuestionNumber &&
          this.state.infoModal === "true" && (
            <Modal
              isOpen={this.state.infoModal_bool}
              centered={true}
              style={{ maxWidth: "1000px" }}
            >
              <ModalBody>
                <div className="d-flex flex-row">
                  <div className="col-1 px-0"></div>
                  <div className="col-10 px-0">
                    <div className="d-flex flex-row flex-wrap justify-content-between">
                      <div>
                        <h3>Things to keep in mind</h3>
                      </div>
                      <div>
                        <button
                          onClick={this.infoToggle}
                          className="btn-red text-white btn-sm text-uppercase "
                          type="submit"
                        >
                          Begin Questionnaire
                        </button>
                      </div>
                    </div>
                    <div
                      style={{ border: "1px solid grey" }}
                      className="py-5 mt-5 d-flex flex-row flex-wrap justify-content-center"
                    >
                      <div className="col-12 col-md-4 px-0">
                        <div className="d-flex flex-row flex-wrap justify-content-center">
                          <div className="col-12 text-center mb-2 px-0">
                            <span className="fa-stack fa-2x">
                              <i className="fas fa-circle text-secondary"></i>
                              <span
                                style={{ fontSize: "16px" }}
                                className="fa-stack-1x text-white"
                              >
                                1
                              </span>
                            </span>
                          </div>
                          <div className="col-12 text-center px-0">
                            <img
                              style={{ width: "35%" }}
                              className="img-fluid"
                              src={Stopwatch}
                            />
                          </div>
                          <div className="col-12 mt-2 text-center px-1 text-muted">
                            <p style={{ fontSize: "16px" }}>
                              Respond to all the questions in one go.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 px-0">
                        <div className="d-flex flex-row flex-wrap justify-content-center">
                          <div className="col-12 text-center mb-2 px-0">
                            <span className="fa-stack fa-2x">
                              <i className="fas fa-circle text-secondary"></i>
                              <span
                                style={{ fontSize: "16px" }}
                                className="fa-stack-1x text-white"
                              >
                                2
                              </span>
                            </span>
                          </div>
                          <div className="col-12 text-center px-0">
                            <img
                              style={{ width: "35%" }}
                              className="img-fluid"
                              src={Honesty}
                            />
                          </div>
                          <div className="col-12 mt-2 text-center px-1 text-muted">
                            <p style={{ fontSize: "16px" }}>
                              Be honest in your responses.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-12 col-md-4 px-0">
                        <div className="d-flex flex-row flex-wrap justify-content-center">
                          <div className="col-12 text-center mb-2 px-0">
                            <span className="fa-stack fa-2x">
                              <i className="fas fa-circle text-secondary"></i>
                              <span
                                style={{ fontSize: "16px" }}
                                className="fa-stack-1x text-white"
                              >
                                3
                              </span>
                            </span>
                          </div>
                          <div className="col-12 text-center px-0">
                            <img
                              style={{ width: "44%" }}
                              className="img-fluid"
                              src={Neutral}
                            />
                          </div>
                          <div className="col-12 mt-2 text-center px-1 text-muted">
                            <p style={{ fontSize: "16px" }}>
                              Do not leave any response neutral
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-1"></div>
                </div>
              </ModalBody>
            </Modal>
          )
          : null}

        {(this.props.currentDashboardObj.assessment_status__status_name !==
          "Yet to start" ||
          this.state.infoModal === "false") && (
            <div className="working">


              {currentQuestion != null ? (
                <div>
                  {currentQuestion.question_number ===
                    this.props.FirstQuestionNumber && (
                      <Joyride
                        continuous
                        showProgress
                        showSkipButton
                        disableScrolling={false}
                        steps={steps}
                        disableOverlayClose
                        run={true}
                        callback={this.handleJoyrideCallback}
                        disableCloseOnEsc={true}
                        spotlightPadding={0}
                        spotlightClicks={false}
                        styles={{
                          options: {

                            width: 700,
                          },
                        }}
                      />
                    )}
                  <React.Fragment>

                    <div className="questions-wrapper">
                      <QuestionCrumbs
                        questionsList={this.props.mainData.questions_list}
                        currentQuestion={this.state.question_itration}
                      />
                    </div>
                    <div className="text-wrapper">
                      <h1
                        className="question-header animation-fade-in"
                        style={{
                          paddingBottom: 0,
                          marginBottom: 0,
                          color: "#30c535",
                          fontSize: "16px",
                        }}
                      >
                        Q{this.state.question_itration}
                      </h1>
                      <h3 className="question mb-0">
                        {currentDashboardObj.participant__id != undefined
                          ? currentQuestion.user_questions.question_statement_self
                          : currentDashboardObj.user_assessment__participant__gender ==
                            "1"
                            ? `${currentQuestion.user_questions.question_statement_male}`.replace(
                              "#Name",
                              `${currentDashboardObj.user_assessment__participant__full_name}`
                            )
                            : currentDashboardObj.user_assessment__participant__gender ==
                              "2"
                              ? `${currentQuestion.user_questions.question_statement_female}`.replace(
                                "#Name",
                                `${currentDashboardObj.user_assessment__participant__full_name}`
                              )
                              : `${currentQuestion.user_questions.question_statement_others}`.replace(
                                "#Name",
                                `${currentDashboardObj.user_assessment__participant__full_name}`
                              )}
                      </h3>
                    </div>
                  </React.Fragment>
                  <div className="panel-one animation-fade-in"></div>

                  <div className="questionaire-rating-wrapper">
                    <div
                      className="animation-fade-in"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        height: 80,
                        marginTop: 100,
                        width: "1110px",
                      }}
                    >
                      {this.state.options.map((obj, key) => (
                        <div
                          className="rating-bar-wrapper"
                          key={key}
                          style={{
                            flex: obj.option_end_value - obj.option_start_value,
                            flexDirection: "column",
                          }}
                        >
                          <div className="rating-bar">
                            <p>{key + 1}</p>
                          </div>

                          <div
                            style={{

                              alignItems: "center",
                            }}
                          >
                            <p
                              className="options"
                              style={{
                                textAlign:
                                  "center",
                                fontSize: 12,
                                paddingLeft: 10,
                                paddingRight: 10,
                                fontWeight: 600,
                                color: "#9e9e9e",
                              }}
                            >
                              {obj.option_name}
                            </p>
                          </div>

                        </div>
                      ))}
                    </div>
                    <div
                      className="panel-three animation-fade-in position-relative mt-5"
                      style={{ marginLeft: -10, marginRight: -10 }}
                    >
                      <div
                        className="input-range-value-container"
                        style={{
                          left: this.state.value * 10 + "%",
                        }}
                      >
                        <div className="tear-drop-img-wrapper">
                          <img
                            src={Ratingtear}
                            alt="tear-drop"
                            className="rating-tear"
                          />

                          <p>{this.state.value}</p>
                        </div>
                      </div>
                      <InputRange
                        maxValue={10}
                        minValue={0}
                        value={this.state.value}
                        step={0.01}
                        onChange={(value) => this.progress(value)}
                        onChangeComplete={(value) => this.onComplete(value)}

                      />
                    </div>
                  </div>

                  <div
                    className="animation-fade-in"
                    style={{ textAlign: "center", margin: "15px 0" }}
                  >
                    <Button
                      disabled={this.state.disableNextButton}
                      className={
                        this.props.mainData.no_of_questions ==
                          this.state.question_count
                          ? "btn bg-gray btn-sm text-uppercase text-white panel-four"
                          : this.state.initial_green_indicator == false
                            ? "disableButton btn bg-gray btn-sm text-uppercase panel-four"
                            : "btn btn-red btn-sm text-uppercase panel-four"
                      }
                      onClick={() =>
                        this.onClickButton(
                          this.props.mainData.no_of_questions,
                          this.state.question_count
                        )
                      }
                      style={{
                        margin: "2px",
                        fontSize: "16px",
                        paddingTop: 10,
                        paddingBottom: 10,
                        paddingRight: 50,
                        paddingLeft: 50,
                      }}
                    >
                      {this.props.mainData.no_of_questions - 1 ==
                        this.state.question_count ? (
                        "Submit"
                      ) : this.state.disableNextButton ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : (
                        "Next"
                      )}
                    </Button>
                  </div>
                </div>
              ) : null}
              <footer
                style={{
                  backgroundColor: "rgb(225, 225, 225)",
                  paddingTop: 20,
                  left: 0,
                  right: 0,
                  paddingBottom: 20,
                  position: "fixed",
                  bottom: 0,
                  textAlign: "center",
                }}
              >
                <ProgressBar
                  max={this.props.mainData.no_of_questions}
                  value={this.state.question_count}
                  striped={true}
                  height={true}
                />
              </footer>
            </div>
          )}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {

  return {};
}

export default connect(mapStateToProps)(MultiRater);



// WEBPACK FOOTER //
// ./src/_pages/Assessments/MultiRater/index.jsx